export default {
  showThumbnails: 'Показати мініатюри',
  close: 'Закрити галерею',
  zoomIn: 'Збільшення',
  source: 'Джерело',
}
